import { ComponentType } from '@angular/cdk/portal';
import { TemplateRef } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { createAction, props } from '@ngrx/store';

import { UserLanguageDto } from '@core/users/user.model';

import { CurrentUserDto } from './auth/current-user.model';
import { PortalSettingsDto } from './portal-settings/portal-settings.model';
import { ErrorDto } from './shared/error.model';

export const loadPortalSettings = createAction('[Platform] Load Portal Settings');

export const loadPortalSettingsSucceeded = createAction(
  '[Platform] Load Portal Settings Succeeded',
  props<{ portalSettings: PortalSettingsDto }>(),
);

export const loadPortalSettingsFailed = createAction(
  '[Platform] Load Portal Settings Failed',
  props<{ status: number; errors: ErrorDto }>(),
);

export const setIdentityClaims = createAction('[Platform] Set Identity Claims', props<{ identityClaims: any }>());

export const openDialog = createAction(
  '[Platform] Open Dialog',
  props<{ componentOrTemplateRef: ComponentType<any> | TemplateRef<any>; config?: MatDialogConfig<any> }>(),
);
export const dialogOpened = createAction('[Platform] Dialog Opened', props<{ id: string }>());
export const closeDialog = createAction('[Platform] Close Dialog', props<{ id: string; data?: any }>());
export const dialogClosed = createAction('[Platform] Dialog Closed', props<{ id: string; data?: any }>());

export const loadCurrentUser = createAction('[Platform] Load Current User');

export const loadCurrentUserSucceeded = createAction('[Platform] Load Current User Succeeded', props<{ user: CurrentUserDto }>());

export const loadCurrentUserFailed = createAction('[Platform] Load Current User Failed', props<{ status: number; errors: ErrorDto }>());

export const postCurrentUserLanguage = createAction('[Platform] Post Current User Language', props<{ language: UserLanguageDto }>());

export const showProgressBar = createAction('[Platform] Show Progress Bar');

export const hideProgressBar = createAction('[Platform] Hide Progress Bar');

export const increaseProgressBar = createAction('[Platform] Increase Progress Bar');

export const logout = createAction('[Platform] Logout');
